import React, { Component } from 'react';
import { Spinner } from 'react-bootstrap';

export default class Transactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mytrans: [], spinner: true, modelbox: false, modelbox1: false, bal: 0, qr1: '', qr2: '', upi1: '', upi2: '', modelbox2: false, deposites: [],
      acc_name: '', acc_number: '', acc_type: '', ifsc_code: '', bank_name: '', banks: [], upi_modal: false,
      withdrawls: [], depo_amt: '', depo_remarks: '', open_tab: 'depo', showbank: false, depo_modal: false, showqr: '', usd: 0, getusd: '', wusd: 0,
      assetsLoaded: true, withdrawAmt: '', account_holder: '', account_no: '',
      username: '', client_id: ''
    }
  }

  async pageRefresh() {
    this.setState({ spinner: true });
    var userid = localStorage.getItem('userid');
    
    
    const wurl = 'https://octafxx.in/Rest/mytrans_api/'+userid;
    fetch(wurl).then((response) => response.json())
      .then((responseJson) => {
        this.setState({ spinner: false });
        this.setState({ mytrans: responseJson })
      }).catch((error) => {
        console.log(error);
        this.setState({ spinner: false });
      });
  }

  statusCol(st) {
    if (st == 'Pending') { return '#F59E0B' }
    if (st == 'Approved') { return '#10B981' }
    if (st == 'Reject') { return '#EF4444' }
    return '#666666'
  }

  componentDidMount() {
    this.setState({ 
      username: localStorage.getItem('name') || 'User', 
      client_id: localStorage.getItem('userid') || '' 
    });
    this.pageRefresh();
  }

  changeColor(type) {
    if (type == 'Credit' || type == 'Trade Credit') {
      return '#10B981'
    } else {
      return '#EF4444'
    }
  }

  getTotalCredits() {
    return this.state.mytrans.filter(t => t.tr_type === 'Credit' || t.tr_type === 'Trade Credit')
      .reduce((sum, t) => sum + parseFloat(t.tr_amt || 0), 0).toFixed(2);
  }

  getTotalDebits() {
    return this.state.mytrans.filter(t => t.tr_type === 'Debit' || t.tr_type === 'Withdrawal')
      .reduce((sum, t) => sum + parseFloat(t.tr_amt || 0), 0).toFixed(2);
  }

  render() {
    return (
      <div className="min-vh-100" style={{ backgroundColor: '#F8F9FA' }}>
        {/* Loading Spinner */}
        {this.state.spinner && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
            <div className="bg-white p-4 rounded-4 text-center shadow-lg">
              <Spinner animation="border" variant="primary" style={{ width: 40, height: 40 }} />
              <div className="mt-3 text-secondary fw-semibold" style={{ fontFamily: 'custom-fonts' }}>Loading...</div>
            </div>
          </div>
        )}

        {/* Main Content */}
        <div className="p-3" style={{ flex: 1 }}>
          {/* Header Card */}
          <div className="bg-white rounded-4 p-3 mb-3 shadow-sm" style={{ 
            borderWidth: 1, 
            borderColor: '#E8E8E8',
            boxShadow: '0 4px 12px rgba(0,84,189,0.08)'
          }}>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div className="small fw-semibold mb-1" style={{ color: '#0054bd', letterSpacing: 0.5 }}>TRANSACTION HISTORY</div>
                <div className="fw-bold" style={{ fontSize: 18, color: '#1A1A1A' }}>Your Financial Activity</div>
              </div>
              <div className="d-flex justify-content-center align-items-center rounded-circle" style={{
                width: 44,
                height: 44,
                backgroundColor: 'rgba(0, 84, 189, 0.1)',
                borderWidth: 1,
                borderColor: 'rgba(0, 84, 189, 0.2)'
              }}>
                <i className="bi bi-arrow-left-right" style={{ fontSize: 24, color: '#0054bd' }}></i>
              </div>
            </div>

            {/* Summary Stats */}
            <div className="d-flex justify-content-between mt-3 pt-3" style={{ borderTop: '1px solid #F0F0F0' }}>
              <div>
                <div className="small mb-1" style={{ color: '#999999' }}>Total Credits</div>
                <div className="fw-bold" style={{ fontSize: 16, color: '#10B981' }}>+${this.getTotalCredits()}</div>
              </div>
              <div className="text-end">
                <div className="small mb-1" style={{ color: '#999999' }}>Total Debits</div>
                <div className="fw-bold" style={{ fontSize: 16, color: '#EF4444' }}>-${this.getTotalDebits()}</div>
              </div>
            </div>
          </div>

          {/* Transactions List */}
          <div className="pb-4">
            {this.state.mytrans.length > 0 ? (
              <div className="d-flex flex-column gap-2">
                {this.state.mytrans.map((item, index) => {
                  const isCredit = item.tr_type === 'Credit' || item.tr_type === 'Trade Credit';
                  const amount = Math.abs(parseFloat(item.tr_amt || 0)).toFixed(2);
                  
                  return (
                    <div
                      key={index}
                      className="bg-white rounded-3 p-3 d-flex justify-content-between align-items-center"
                      style={{
                        borderWidth: 1,
                        borderColor: '#E8E8E8',
                        transition: 'all 0.3s ease',
                        animation: `slideInUp ${0.3}s ease ${index * 0.05}s both`,
                        cursor: 'pointer'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      {/* Left Content */}
                      <div className="d-flex align-items-center flex-grow-1">
                        <div className="d-flex justify-content-center align-items-center rounded-circle me-3" style={{
                          width: 44,
                          height: 44,
                          backgroundColor: isCredit ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)'
                        }}>
                          <i className={`bi ${isCredit ? 'bi-arrow-down-circle' : 'bi-arrow-up-circle'}`} style={{
                            fontSize: 24,
                            color: isCredit ? '#10B981' : '#EF4444'
                          }}></i>
                        </div>

                        <div>
                          <div className="fw-semibold mb-1" style={{ fontSize: 14, color: '#1A1A1A' }}>{item.tr_type}</div>
                          <div className="small" style={{ color: '#999999' }}>{item.tr_date}</div>
                        </div>
                      </div>

                      {/* Right Content */}
                      <div className="text-end">
                        <div className={`fw-bold mb-1 ${isCredit ? 'text-success' : 'text-danger'}`} style={{ fontSize: 15 }}>
                          {isCredit ? '+' : '-'}${amount}
                        </div>
                        <div className="px-2 py-1 rounded-2" style={{ backgroundColor: '#F8F9FA', border: '1px solid #E8E8E8' }}>
                          <div className="small fw-semibold" style={{ color: '#0054bd' }}>Balance: ${parseFloat(item.left_amt || 0).toFixed(2)}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-center py-5 px-3 bg-white rounded-4 border mt-3">
                <div className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle" style={{ width: 70, height: 70, backgroundColor: '#F8F9FA' }}>
                  <i className="bi bi-receipt" style={{ fontSize: 35, color: '#CCCCCC' }}></i>
                </div>
                <div className="fw-semibold mb-2" style={{ fontSize: 16, color: '#666666' }}>No Transactions</div>
                <div className="small text-secondary text-center">Your transaction history will appear here</div>
              </div>
            )}
          </div>
        </div>

        <style>{`
          @keyframes slideInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          * {
            font-family: 'Muli', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          }
          
          .btn:focus, .btn:active {
            outline: none;
            box-shadow: none;
          }
          
          /* Custom scrollbar */
          ::-webkit-scrollbar {
            width: 4px;
          }
          
          ::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
          }
          
          ::-webkit-scrollbar-thumb {
            background: #0054bd;
            border-radius: 4px;
          }
          
          ::-webkit-scrollbar-thumb:hover {
            background: #003d8a;
          }
        `}</style>
      </div>
    );
  }
}